import script from "./SelectionCriteria.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectionCriteria.vue?vue&type=script&setup=true&lang=js"

import "./SelectionCriteria.vue?vue&type=style&index=0&id=2afbc1e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2afbc1e6"]])

export default __exports__